import { stat } from "fs";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routerNameChanger } from "../util/routerNameChanger";
import dayjs from "dayjs";

const useDiagnosisContextMenu = () => {
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = useState<any>(null);
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    path: "",
  });
  // 작업중인지 확인
  const [clear, setClear] = useState(false);

  useEffect(() => {
    const handleClickOutside = () => {
      setContextMenu({ visible: false, x: 0, y: 0, path: "" });
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleContextMenu = (event: React.MouseEvent, data: any) => {
    setSelectedData(data);
    if (data) {
      event.preventDefault();
      setContextMenu({
        visible: true,
        x: event.pageX,
        y: event.pageY,
        path: "",
      });
    }
  };

  // 상태 진단 탭으로 이동 클릭 시 동작
  const handleOpenInNewTab = (callback: Function) => {
    if (selectedData !== null) {
      setContextMenu({ visible: false, x: 0, y: 0, path: "" });
      // 임시
      navigate(
        `/equipment/${
          routerNameChanger?.(selectedData?.ste_mcy_name).routerName
        }/2`,
        {
          state: {
            search: {
              shipTypeNo: selectedData?.ste_shiptype_no,
              shipNo: selectedData?.ste_ship_no,
              mcyNo: "DG01",
              mcyName: selectedData?.ste_mcy_name,
              lowMcyName: selectedData?.ste_low_mcy_name,
              sensorCode: selectedData?.ste_sensor_code,
              startDate: dayjs(selectedData?.ste_alarm_time).format(
                "YYYY-MM-DD"
              ),
            },
          },
        }
      );
      callback?.();
    }
  };

  return {
    contextMenu,
    handleContextMenu,
    handleOpenInNewTab,
    clear,
  };
};

export default useDiagnosisContextMenu;
